
    import { ShiftTeamTypeModel } from '@/libs/Api';
    import { CrudGetter } from '@/libs/core/+state/models/crud-getter';
    import { Component, Prop, Ref, VModel, Vue } from 'vue-property-decorator';
    import Autocomplete from '../components/Autocomplete.vue';
    import { shiftTeamTypesStore } from '@/libs/shift-team-types/+state/store';
    
    @Component({})
    export default class ShiftTeamTypeSelect extends Vue {
    @VModel() innerValue!: string | string[] | null;
    @Prop({ default: '' }) label!: string;
    @Prop() readonly!: boolean;
    @Prop() rules!: [any[]];
    @Prop({ default: false }) required!: boolean;
    @Prop({ default: false }) dense!: boolean;
    @Prop({ default: false }) multiple!: boolean;
    @Prop({ default: true }) hideDetails!: boolean;
    @Prop({ default: true }) clearable!: boolean;
    @Prop({ default: false }) truncateSelection!: boolean;
    @Prop() placeholder!: string;
    @Prop() attach!: string;
    
        @Ref() autocomplete!: Autocomplete;
    
        get items(): ShiftTeamTypeModel[] {
            const list = (shiftTeamTypesStore.useGetter(CrudGetter.Data) ?? []) as ShiftTeamTypeModel[];
            return [...list].sort((a, b) => ((a?.name || '') < (b?.name || '') ? -1 : (a?.name || '') > (b?.name || '') ? 1 : 0));
        }
    
        onChange(e: any) {
            const all = (shiftTeamTypesStore.useGetter(CrudGetter.Data) ?? []) as ShiftTeamTypeModel[];
            this.$emit('input', e);
            this.$nextTick(() => {
                this.$emit('change', e);
                const id = Array.isArray(e) ? (e[0] ?? null) : e;
                this.$emit('select', all.find((x) => (x as any).id === id) ?? null);
            });
        }
    }
    